module.exports = __webpack_public_path__ + "img/Shiba-BG.14671359.jpg";